'use client'
import { axiosAdmin } from "@/lib/axios";
import { useAuthStore } from "@/store/AuthStore";
import { useQuery } from "@tanstack/react-query";

export function useGetWishlistItems() {
  const accessToken = useAuthStore((state) => state.accessToken);
  return useQuery({
    queryKey: ['getallwishlist'],
    queryFn: async () => {
      try {
        const response = await axiosAdmin.get("/user/wishlist");
        return response?.data;
      } catch (error) {
        throw error;
      }
    },
    enabled: Boolean(accessToken), // Reactive: updates when user logs in/out
    staleTime: 5 * 60 * 1000, // Cache wishlist data to prevent redundant background fetches
  });
}
